import { render, staticRenderFns } from "./successResult.vue?vue&type=template&id=24777f83"
import script from "./successResult.vue?vue&type=script&lang=js"
export * from "./successResult.vue?vue&type=script&lang=js"
import style0 from "./successResult.vue?vue&type=style&index=0&id=24777f83&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports